import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaCalendarPlus, FaBalanceScale } from 'react-icons/fa';
import './LeaveTabs.css';

const LeaveTabs = () => {
  return (
    <div className="leave-tabs-container">

      {/* HEADER */}
      <div className="leave-header-card">
        <div className="leave-header">
          <h1 className="leave-title">Leave Management</h1>
          <p className="leave-subtitle">
            Apply Leaves and Keep an eye on your Leave Balance
          </p>
        </div>
      </div>

      {/* TABS */}
      <div className="leave-nav-tabs">

        <NavLink
          to="/leave/add-leave"
          className={({ isActive }) => `leave-tab ${isActive ? 'active' : ''}`}
        >
          <FaCalendarPlus className="tab-icon" />
          <span>Apply Leave</span>
        </NavLink>

        <NavLink
          to="/leave/leave-balance"
          className={({ isActive }) => `leave-tab ${isActive ? 'active' : ''}`}
        >
          <FaBalanceScale className="tab-icon" />
          <span>Leave Balance</span>
        </NavLink>

      </div>
    </div>
  );
};

export default LeaveTabs;
